<!-- eslint-disable no-fallthrough -->
<!--
 * @description: 首页图片
 * @param: 
 * @return: 
-->
<template>
  <div class="tabel-container">
    <div class="tabel-box">
      <div class="title-container" :style="titleBg">
          最新报修信息
      </div>
      <div class="border-bottom-sigln"></div>
       <!-- @click="handleClick(row)" -->
        <el-table :data="source" style="width: 100%">
          <el-table-column prop="CompName" label="客户名称" />
          <el-table-column prop="ModelNoStr" label="设备类型" />
          <el-table-column prop="SerialNoName" label="SN号" />
          <el-table-column prop="CusApp" label="故障信息" />
          <el-table-column prop="AddDate" label="保修日期" />
          <el-table-column prop="States" label="处理状态">
              <template #default="{row}">
                  <span 
                  class="spanStyle" 
                  :style="{'color':row.color}"
                  >
                
                  {{row.States}}
                  </span>
              </template>
          </el-table-column>
        </el-table>
      
    </div>
  </div>
</template>

<script>
import panelContainer from "@/components/panelContainer.vue";
import field from "@/components/textField.vue";
import searchButton from "@/components/searchButton.vue";
import cardPanel from "@/components/cardPanel.vue";
import chart from "@/components/vChart.vue";
import tabelApi from "@/api/tabel.js";
import // getToolsTimes,
// payBackTimes,
// orgEachUninWarehouseInfo,
// warehouseInfo
"@/api/index.js";
import { errMsg } from "@/notify/index.js";
import { defineComponent, reactive, toRefs, onMounted, computed } from "vue";

export default defineComponent({
  name: "ChartReports",
  components: {
    panelContainer,
    field,
    searchButton,
    cardPanel,
    chart,
  },
  props: {
    titleBg: Object,
  },
  setup(porps) {
    let data = reactive({
      source: [
        {
          date: "2016-05-03",
          name: "Tom",
          address: "No. 189, Grove St, Los Angeles",
          a: 123,
          b: 456,
          c: 789,
          color:'red'
        },
        {
          date: "2016-05-02",
          name: "Tom",
          address: "No. 189, Grove St, Los Angeles",
          a: 123,
          b: 456,
          c: 789,
          color:'yellow'
        },
        {
          date: "2016-05-04",
          name: "Tom",
          address: "No. 189, Grove St, Los Angeles",
          a: 123,
          b: 456,
          c: 789,
          color:'#999'
        },
        {
          date: "2016-05-01",
          name: "Tom",
          address: "No. 189, Grove St, Los Angeles",
          a: 123,
          b: 456,
          c: 789,
          color:'rgb(21,202,55)'
        },
      ],
    });
    onMounted(()=>{
      console.log('@--', porps)
      methods.getSource()
    })
    // 使用计算属性
    let inforList = computed(() => {
      return 'zxx'
    });
   let methods = {
        handleClick(row){
            switch(row.States){
                case "待接收" :
                    errMsg('珍惜')
                breack;
                 // eslint-disable-next-line no-fallthrough
                 case "已发回" :
                    errMsg('hello')
                breack;
                 // eslint-disable-next-line no-fallthrough
                 case "维修中" :
                    errMsg('维修中')
                breack;
                  // eslint-disable-next-line no-fallthrough
                 case "已完成" :
                    errMsg('已完成')
                breack;
                  // eslint-disable-next-line no-fallthrough
                case "已撤单" :
                    errMsg('已撤单')
                breack;
            }
        },
        getSource(){
          tabelApi.VisRepairDesc().then(res=>{
            console.log(res,'footer')
            res.data.list.forEach(item=>{
              item.color=item.States=='待接收'?'red':item.States=="已发回"
              ?'blue':item.States=="已完成"?
              'rgb(21,202,55)':item.States=="维修中"
              ?'rgb(222,203,0)':'rgb(123,123,123)'
            })
            data.source=res.data.list


          })
        },
    };
    onMounted(() => {});

    return {
      inforList,
      ...toRefs(data),
      ...methods,
    };
  },
});
</script>

<style lang="scss" scoped>
.tabel-container {
  width: 100%;
  flex:1;
  height:auto ;//252px
  background-color:white;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  .tabel-box {
    // padding: 0 15px;
    padding-bottom:8px;
    box-sizing:border-box;
    height:100%;
    display:flex;
    flex-direction:column;
    
    :deep(.el-table){
      flex:1;
    }
    .title-container{
        height:32px;
        line-height: 32px;
        padding-left: 20px;
        font-size:14px;
    }
    .border-bottom-sigln{
        height: 2px;
        width:100%;
        background-color:rgb(233,233,233);
        margin-bottom:5px;
        position:relative;
        // left:-15px;
    }
    .spanStyle{
        display:inline-block;
        width:80px;
        color:white;
        font-size:16px;
        border-radius:5px;
        height: 30px;
        text-align:center;
        line-height:30px;
    }
  }
}
.title{
		font-weight: bold;
		background: #E8E8E8;  
}
</style>
